import React from "react";

const DropdownIndicator = () => <span className="dropdownToggle" />;

export default DropdownIndicator;
